module.exports = __webpack_public_path__ + "img/Selection_010.d6a28694.png";